import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { PieChartConfig } from '../../../../../shared/google-chart/Models/PieChartConfig';

@Component({
	selector: 'app-idle-times-alert',
	templateUrl: './idle-times-alert.component.html',
	styleUrls: ['./idle-times-alert.component.css']
})
export class IdleTimesAlertComponent implements OnInit, OnChanges {

	@Input() data: any;
	@Input() siteId: number = 0;
	@Input() customerId: number = 0;
	@Input() customerName: string = '';
	@Input() siteName: string = '';

	config: PieChartConfig;
	tableColumns: any[] = [];
	title: string = 'Idle Times After Event Alert';
	elementId: string = 'idle_times_alert';
	widgetClass: string = 'height-530';
	siteWidgetOptions: any = {
		hasDate: true,
		isAlertWidget: true
	};

	constructor() { }

	ngOnInit() {
	
		this.config = new PieChartConfig({
			colors: [
				{ color: '#109618' },
				{ color: '#bd2f26' },
			]
		});
		
		this.config.formatFunction = (data) => {
			let formattedData: any[] = [
				[
					{"label": "Name", "type": "string"},
					{"label": "Value", "type": "number"}
				]
			];

			formattedData.push([{v: "No Alerts"}, {v: data.Pie[0].ok}]);
			formattedData.push([{v: "Idle Time Alert"}, {v: data.Pie[1].one_or_more}]);
			return formattedData;
		};
	}
	
	ngOnChanges(changes) {
		if(this.data) {
			let tableColumns = [{title: "Battery ID", property: "battery_id"}];
			if (this.data.siteSettings.userSettings.view_truck_id) {
				tableColumns.push({title: "Truck ID", property: "truck_id"});
			}
			tableColumns.push({title: "Expected Idle After Event Time (mins)", property: "expected_idle_time"});
			tableColumns.push({title: "Actual Idle After Event Time (mins)", property: "actual_idle_time"});
			this.tableColumns = tableColumns;
		}
	}
}
